export enum WorkOrderStatus {
    created = 'created',
    finished = 'finished',
    invoiced = 'invoiced',
    cancelled = 'cancelled',
}
